import SvgIcon from "@/pages/home/components/SvgIcon";
import CommonBubble from "@home/components/CommonBubble";
import FormatHtmlTextToReact from "@home/components/FormatHtmlTextToReact";
import moment from "moment";
import React from "react";

export default function MetricCardTitle(props: any) {
  const { isRealTime, isDark, jumpUrl = '', isNightingale, dataSource, isShowIcon = true } = props;
  const {
    name,
    preName,
    endName,
    icon,
    explain,
    bubbleData = {}
  } = dataSource || {};

  const dodTime = bubbleData?.dod?.this_time;
  const formattedTime = dodTime && moment(dodTime).isValid() ? moment(dodTime).format('HH:mm') : '';
  let className = '';

  if (isRealTime) {
    className = 'overlay-card-realtime-text';
  } else if (isDark) {
    className = 'overlay-card-text';
  }

  return (
    <div className={isDark ? 'overlay-card-title' : 'overlay-card-metric-title'}>
      {icon && isShowIcon && (
        <div className={isDark ? '' : "overlay-card-metric-title-icon"}>
          <SvgIcon type={icon} className={isDark ? 'overlay-card-icon' : 'text-icon'} />
        </div>
      )}
      <CommonBubble
        dark
        placement="top"
        content={FormatHtmlTextToReact({ text: explain, className: 'overlay-card-desc'})}
      >
        <div className={`overlay-card-text-box ${className}`}>
          <span className="overlay-card-text-pre">{preName}</span>
          <span className="overlay-card-text-name">{name}</span>
          {(jumpUrl && jumpUrl !== "none") && <span className="overlay-card-text-icon">
            <SvgIcon className='overlay-card-right-icon' type='arrow-right' />
          </span>}
          { endName && <span className="overlay-card-text-end">{endName}</span>}
        </div>
      </CommonBubble>
     
      {isNightingale && <span className='overlay-card-time'>{formattedTime}</span>}
    </div>
  );

}